export enum ETypeFavorite {
  Drug = 'MEDICAMENTO',
  Prescription = 'PRESCRICAO',
}
